import * as PIXI from 'pixi.js'

class Score {
  constructor (game) {
    this.game = game
    this.value = 0
    this.times = 8

    //
    // Hooks
    //

    this.inTheMorning = null
    this.atNoon = null
    this.inTheNight = null

    this.levels = {
      scoreText1: PIXI.Texture.from('score-1-1'),
      scoreText2: PIXI.Texture.from('score-1-2'),
      scoreText3: PIXI.Texture.from('score-1-3'),
      scoreText4: PIXI.Texture.from('score-7-1'),
      scoreText5: PIXI.Texture.from('score-8-2'),
      scoreText6: PIXI.Texture.from('score-8-3'),
      scoreText7: PIXI.Texture.from('score-8-1'),
      scoreText8: PIXI.Texture.from('score-8-2'),
      scoreText9: PIXI.Texture.from('score-8-3')
    }

    this.day = PIXI.Texture.from('day')
    this.colon = PIXI.Texture.from('colon')
    this.numbers = {
      n0: PIXI.Texture.from('num_0'),
      n1: PIXI.Texture.from('num_1'),
      n2: PIXI.Texture.from('num_2'),
      n3: PIXI.Texture.from('num_3'),
      n4: PIXI.Texture.from('num_4'),
      n5: PIXI.Texture.from('num_5'),
      n6: PIXI.Texture.from('num_6'),
      n7: PIXI.Texture.from('num_7'),
      n8: PIXI.Texture.from('num_8'),
      n9: PIXI.Texture.from('num_9')
    }

    this.currentNumbers = {
      d0: '0',
      d1: '0',
      d2: '0',
      h0: '0',
      h1: '0',
      m0: '0',
      m1: '0'
    }

    this.dAnimes = [null, null, null]
    this.hAnimes = [null, null]
    this.mAnimes = [null, null]

    this.h0 = new PIXI.Sprite(this.numbers.n0)
    this.h1 = new PIXI.Sprite(this.numbers.n0)
    this.m0 = new PIXI.Sprite(this.numbers.n0)
    this.m1 = new PIXI.Sprite(this.numbers.n0)
    this.d0 = new PIXI.Sprite(this.numbers.n0)
    this.d1 = new PIXI.Sprite(this.numbers.n0)
    this.d2 = new PIXI.Sprite(this.numbers.n0)
    this.textDay = new PIXI.Sprite(this.day)
    this.colon = new PIXI.Sprite(this.colon)

    this.container = new PIXI.Container()
    this.container.addChild(
      this.textDay,
      this.d0,
      this.d1,
      this.d2,
      this.h0,
      this.h1,
      this.colon,
      this.m0,
      this.m1
    )

    this.textDay.scale.set(0.25)
    this.d0.scale.set(0.25)
    this.d1.scale.set(0.25)
    this.d2.scale.set(0.25)
    this.h0.scale.set(0.25)
    this.h1.scale.set(0.25)
    this.colon.scale.set(0.25)
    this.m0.scale.set(0.25)
    this.m1.scale.set(0.25)

    this.d0.pivot.x = this.d0.width / 2
    this.d1.pivot.x = this.d1.width / 2
    this.d2.pivot.x = this.d2.width / 2
    this.h0.pivot.x = this.h0.width / 2
    this.h1.pivot.x = this.h1.width / 2
    this.m0.pivot.x = this.m0.width / 2
    this.m1.pivot.x = this.m1.width / 2

    this.d0.pivot.y = 0
    this.d1.pivot.y = 0
    this.d2.pivot.y = 0
    this.h0.pivot.y = 0
    this.h1.pivot.y = 0
    this.m0.pivot.y = 0
    this.m1.pivot.y = 0

    this.textDay.x = 20
    this.d0.x = 97
    this.d1.x = 125
    this.d2.x = 153
    this.h0.x = 198
    this.h1.x = 226
    this.colon.x = 248
    this.m0.x = 263
    this.m1.x = 291
  }

  draw (x, y) {
    this.container.y = y
    this.game.app.stage.addChild(this.container)
  }

  update () {
    const [ days, hours, minutes, seconds ] = this.toHHMMSS(this.value)

    if (days.length > 3) {
      return
    }

    // 替換數字材質
    days
      .split('')
      .forEach((digit, index) => {
        if (this.currentNumbers[`d${index}`] === digit) {
          return
        }

        this.currentNumbers[`d${index}`] = digit

        this[`d${index}`].texture = this.numbers[`n${digit}`]

        if (this.dAnimes[index] || !this.game.scenesManager.scene3.nyanMode) {
          return
        }

        this.dAnimes[index] = TweenMax.to(this[`d${index}`], 0.06, {
          pixi: {
            scale: 0.5,
            tint: Math.random() * 0xffffff
          },
          yoyo: true,
          repeat: 1,
          onComplete: () => {
            this.dAnimes[index] = null
          }
        })
      })

    hours
      .split('')
      .forEach((digit, index) => {
        if (this.currentNumbers[`h${index}`] === digit) {
          return
        }

        this.currentNumbers[`h${index}`] = digit

        this[`h${index}`].texture = this.numbers[`n${digit}`]

        if (this.hAnimes[index] || !this.game.scenesManager.scene3.nyanMode) {
          return
        }

        this.hAnimes[index] = TweenMax.to(this[`h${index}`], 0.06, {
          pixi: {
            scale: 0.5,
            tint: Math.random() * 0xffffff
          },
          yoyo: true,
          repeat: 1,
          onComplete: () => {
            this.hAnimes[index] = null
          }
        })
      })

    minutes
      .split('')
      .forEach((digit, index) => {
        if (this.test === 1) {
          // return
        }

        if (this.currentNumbers[`m${index}`] === digit) {
          return
        }

        this.test = 1

        this.currentNumbers[`m${index}`] = digit

        this[`m${index}`].texture = this.numbers[`n${digit}`]

        if (this.mAnimes[index] || !this.game.scenesManager.scene3.nyanMode) {
          return
        }

        this.mAnimes[index] = TweenMax.to(this[`m${index}`], 0.06, {
          pixi: {
            scale: 0.5,
            tint: Math.random() * 0xffffff
          },
          yoyo: true,
          repeat: 1,
          onComplete: () => {
            this.mAnimes[index] = null
          }
        })
      })

    const numHours = Number(hours)
    if (this.isMorning(numHours) && this.inTheMorning) {
      this.inTheMorning()
    } else if (this.isNoon(numHours) && this.atNoon) {
      this.atNoon()
    } else if (this.inTheNight) {
      this.inTheNight()
    }
  }

  increase (delta = 1) {
    this.value += (delta * this.times)
  }

  toHHMMSS (input) {
      let secData = parseInt(input, 10) // don't forget the second param
      let days = Math.floor(secData / (60 * 60 * 24))
      let hours = Math.floor((secData - (days * 60 * 60 * 24)) / (60 * 60))
      let minutes = Math.floor((secData - (days * 60 * 60 * 24) - (hours * 60 * 60)) / 60)
      let seconds = secData - (hours * 60 * 60) - (minutes * 60)

      days = days.toString().padStart(3, '0')
      hours = hours.toString().padStart(2, '0')
      minutes = minutes.toString().padStart(2, '0')
      seconds = seconds.toString().padStart(2, '0')

      return [days, hours, minutes, seconds]
  }

  destroy () {
    this.container.destroy()
    this.h0.destroy()
    this.h1.destroy()
    this.m0.destroy()
    this.m1.destroy()
    this.d0.destroy()
    this.d1.destroy()
    this.d2.destroy()
    this.textDay.destroy()
    this.colon.destroy()

    this.container = null
    this.h0 = null
    this.h1 = null
    this.m0 = null
    this.m1 = null
    this.d0 = null
    this.d1 = null
    this.d2 = null
    this.textDay = null
    this.colon = null
  }

  isMorning (hours) {
    return hours >= 4 && hours < 12
  }

  isNoon (hours) {
    return hours >= 12 && hours < 20
  }

  isNight (hours) {
    return (hours >= 20 && hours < 24) || (hours >= 0 && hours < 4)
  }

  // 這個已經改成為回傳最高分數的成績
  getLevelText () {
    const container = new PIXI.Container()

    const [ days, hours, minutes, seconds ] = this.toHHMMSS(60 * 60 * 24 * 68.5709)

    const obj = {}

    obj.h0 = new PIXI.Sprite(this.numbers.n0)
    obj.h1 = new PIXI.Sprite(this.numbers.n0)
    obj.m0 = new PIXI.Sprite(this.numbers.n0)
    obj.m1 = new PIXI.Sprite(this.numbers.n0)
    obj.d0 = new PIXI.Sprite(this.numbers.n0)
    obj.d1 = new PIXI.Sprite(this.numbers.n0)
    obj.d2 = new PIXI.Sprite(this.numbers.n0)
    obj.textDay = new PIXI.Sprite(PIXI.Texture.from('day'))
    obj.colon = new PIXI.Sprite(PIXI.Texture.from('colon'))

    obj.textDay.scale.set(0.25)
    obj.h0.scale.set(0.25)
    obj.h1.scale.set(0.25)
    obj.m0.scale.set(0.25)
    obj.m1.scale.set(0.25)
    obj.d0.scale.set(0.25)
    obj.d1.scale.set(0.25)
    obj.d2.scale.set(0.25)
    obj.colon.scale.set(0.25)

    obj.textDay.x = 0
    obj.d0.x = 77
    obj.d1.x = 105
    obj.d2.x = 133

    obj.h0.y = 42
    obj.h1.y = 42
    obj.colon.y = 42
    obj.m0.y = 42
    obj.m1.y = 42

    obj.h0.x = 0
    obj.h1.x = 28
    obj.colon.x = 55
    obj.m0.x = 65
    obj.m1.x = 93

    obj.textDay.tint = 0x9acccc
    obj.h0.tint = 0x9acccc
    obj.h1.tint = 0x9acccc
    obj.m0.tint = 0x9acccc
    obj.m1.tint = 0x9acccc
    obj.d0.tint = 0x9acccc
    obj.d1.tint = 0x9acccc
    obj.d2.tint = 0x9acccc
    obj.colon.tint = 0x9acccc

    days
      .split('')
      .forEach((digit, index) => {
        obj[`d${index}`].texture = this.numbers[`n${digit}`]
      })

    hours
      .split('')
      .forEach((digit, index) => {
        obj[`h${index}`].texture = this.numbers[`n${digit}`]
      })

    minutes
      .split('')
      .forEach((digit, index) => {
        obj[`m${index}`].texture = this.numbers[`n${digit}`]
      })

    container.addChild(
      obj.h0,
      obj.h1,
      obj.m0,
      obj.m1,
      obj.d0,
      obj.d1,
      obj.d2,
      obj.textDay,
      obj.colon
    )

    container.scale.set(0.9)

    return container
  }
}

export default Score
